import { Box, Tooltip, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import swapIcon from "../../../assets/icons/swap-icon.png";

export const RelationSwap = ({
	watch,
	setValue,
	setLoadingAddressDefaultValue,
	setUnloadingAddressDefaultValue,
}) => {
	const { t } = useTranslation();

	const loadingData = {
		country: watch("loadingAddressCountry"),
		address: watch("loadingAddress"),
		customPostal: watch("loadingAddressCustomPostalCode"),
		customCity: watch("loadingAddressCustomCity"),
		customCountry: watch("loadingAddressCustomCountry"),
	};

	const unloadingData = {
		country: watch("unloadingAddressCountry"),
		address: watch("unloadingAddress"),
		customPostal: watch("unloadingAddressCustomPostalCode"),
		customCity: watch("unloadingAddressCustomCity"),
		customCountry: watch("unloadingAddressCustomCountry"),
	};

	const handleSwap = () => {
		setValue("loadingAddressCountry", unloadingData.country);
		if (unloadingData.address) {
			setValue("loadingAddress", unloadingData.address);
			setLoadingAddressDefaultValue(unloadingData.address);
			setValue("loadingAddressCustomPostalCode", unloadingData.customPostal);
			setValue("loadingAddressCustomCity", unloadingData.customCity);
			setValue("loadingAddressCustomCountry", unloadingData.customCountry);
		} else {
			const addressObject = {
				title: `${unloadingData.customCountry},${unloadingData.customPostal}, ${unloadingData.customCity}`,
				address: {
					label: `${unloadingData.customCountry},${unloadingData.customPostal}, ${unloadingData.customCity}`,
					countryCode: unloadingData.customCountry,
					city: unloadingData.customCity,
					postalCode: unloadingData.customPostal,
				},
			};
			setValue("loadingAddress", addressObject);
			setLoadingAddressDefaultValue(addressObject);
			setValue("loadingAddressCustomPostalCode", unloadingData.customPostal);
			setValue("loadingAddressCustomCity", unloadingData.customCity);
			setValue("loadingAddressCustomCountry", unloadingData.customCountry);
		}

		setValue("unloadingAddressCountry", loadingData.country);
		if (loadingData.address) {
			setValue("unloadingAddress", loadingData.address);
			setUnloadingAddressDefaultValue(loadingData.address);
			setValue("unloadingAddressCustomPostalCode", loadingData.customPostal);
			setValue("unloadingAddressCustomCity", loadingData.customCity);
			setValue("unloadingAddressCustomCountry", loadingData.customCountry);
		} else {
			const addressObject = {
				title: `${loadingData.customCountry},${loadingData.customPostal}, ${loadingData.customCity}`,
				address: {
					label: `${loadingData.customCountry},${loadingData.customPostal}, ${loadingData.customCity}`,
					countryCode: loadingData.customCountry,
					city: loadingData.customCity,
					postalCode: loadingData.customPostal,
				},
			};
			setValue("unloadingAddress", addressObject);
			setUnloadingAddressDefaultValue(addressObject);
			setValue("unloadingAddressCustomPostalCode", loadingData.customPostal);
			setValue("unloadingAddressCustomCity", loadingData.customCity);
			setValue("unloadingAddressCustomCountry", loadingData.customCountry);
		}
	};

	return (
		<Tooltip
			title={
				<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
					{t("swap_relation")}
				</Typography>
			}
			placement="left"
		>
			<Box
				onClick={handleSwap}
				sx={{
					cursor: "pointer",
					maxWidth: "25px",
					maxHeight: "25px",
					width: "25px",
					height: "25px",
				}}
			>
				<img
					src={swapIcon}
					style={{ height: "100%", width: "100%", objectFit: "contain" }}
					alt="swap relation"
				/>
			</Box>
		</Tooltip>
	);
};
